import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IFirmwareContext, FirmwareContext } from '../../firmwareState/firmwareContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Firmware.module.scss';

const Firmware: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, firmware, currentPage, countOfItems } = useContext<IFirmwareContext>(FirmwareContext);

	return (
		<>
			{firmware.count ? (
				<div className={style.container} data-test="Firmware">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={firmware.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Firmware;
